/** @format */

import {useMemo} from 'react';

import {format} from 'date-fns';

import {useInView} from 'helpers/hooks/useInView';

import {type CardBodyCompany} from '../../types';
import {useOverviewCardBodyQuery} from '../../queries/__generated__';

interface Options {
  companyId: string;
  period: {start: string; end: string} | null;
  now: Date;
}

export const useCardBody = ({companyId, period, now}: Options) => {
  const {ref, inView} = useInView<HTMLDivElement>();

  // Окно тела = точный период активного медиаплана (его и обрезает адаптер). Без разрешённого
  // периода (нет медиаплана / на 1-е число активен завершённый flight) — широкое fallback-окно,
  // чтобы покрыть кросс-месячный/предыдущий факт.
  const {startDate, endDate} = useMemo(() => {
    if (period) {
      return {startDate: period.start, endDate: period.end};
    }
    // Fallback: no resolvable active period (no mediaplan / finished flight active on the 1st).
    // Keep the wide window so cross-month/previous-period fact is still covered.
    return {
      startDate: format(new Date(now.getFullYear(), now.getMonth() - 1, 1), 'yyyy-MM-dd'),
      endDate: format(new Date(now.getFullYear(), now.getMonth() + 2, 0), 'yyyy-MM-dd'),
    };
  }, [period, now]);

  const {data, loading, error, refetch} = useOverviewCardBodyQuery({
    skip: !inView,
    variables: {companyId, startDate, endDate},
  });

  const company: CardBodyCompany | null = data?.currentUser?.company ?? null;

  return {ref, inView, company, loading, error, refetch, now};
};
